import engine from 'store/src/store-engine';
import * as session from 'store/storages/sessionStorage';

window.sessionstore = engine.createStore([session], []); // @TODO: to be removed when all have been transformed

export default engine.createStore([session], []);
